import { useState } from 'react';

export interface DateRange {
  startDate?: number; // unix seconds
  endDate?: number;
}

interface SearchBarProps {
  onSearch: (query: string, range: DateRange) => void;
}

export function SearchBar({ onSearch }: SearchBarProps) {
  const [query, setQuery] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [showDateFilter, setShowDateFilter] = useState(false);

  const toUnixSeconds = (dateStr: string, endOfDay = false): number | undefined => {
    if (!dateStr) return undefined;
    const d = new Date(dateStr + (endOfDay ? 'T23:59:59' : 'T00:00:00'));
    return Math.floor(d.getTime() / 1000);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(query, {
      startDate: toUnixSeconds(startDate),
      endDate: toUnixSeconds(endDate, true),
    });
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border-b border-gray-200 space-y-2">
      <input
        type="text"
        placeholder="Search messages..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <button
        type="button"
        onClick={() => setShowDateFilter(!showDateFilter)}
        className="text-xs text-blue-600 hover:underline"
      >
        {showDateFilter ? 'Hide' : 'Filter by time period'}
      </button>
      {showDateFilter && (
        <div className="flex items-center gap-2">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="flex-1 px-2 py-1 border border-gray-300 rounded text-xs"
            aria-label="Start date"
          />
          <span className="text-xs text-gray-400">to</span>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="flex-1 px-2 py-1 border border-gray-300 rounded text-xs"
            aria-label="End date"
          />
        </div>
      )}
    </form>
  );
}
